import { Navbar, Footer } from "../adminComponents";
import { Link } from "react-router-dom";
import axios from "axios";
import configData from "../config.json";
import { useState, useEffect } from "react";
import * as Icon from 'react-bootstrap-icons';

function Dashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const branchId = localStorage.getItem("eshopBranchID");

  useEffect(() => {
    const getDashboardData = async () => {
      try {
        const response = await axios.get(`${configData.SERVER_ADMIN_URL}/dashboardData/${branchId}`);
        setDashboardData(response.data);
      } catch (err) {
        setError("Failed to load dashboard data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (branchId) {
      getDashboardData();
    } else {
      setError("Branch ID not found");
      setLoading(false);
    }
  }, [branchId]);

  return (
    <>
    <div className="card card-body">
      <div className="container d-flex justify-content-center align-items-center gap-3 flex-wrap" style={{ minHeight: "30vh" }}>
        {/* Loading */}
        {loading && <p>Loading dashboard...</p>}

        {/* Error */}
        {error && <p className="text-danger">{error}</p>}

        {/* Cards */}
        {!loading && !error && dashboardData && (
          <>
            {/* Pending Order */}
            <div className="card text-center shadow" style={{ width: "18rem" }}>
              <div className="card-header bg-info text-white">
                <h6 className="mb-0">Pending Order</h6>
              </div>
              <div className="card-body">
                <Link to={`/admin/orderlist/${branchId}`}>
                  <span className="badge bg-primary fs-6">
                    {dashboardData.pendingOrder ?? 0}
                  </span>
                </Link>
              </div>
            </div>

            {/* Finished Order */}
            <div className="card text-center shadow" style={{ width: "18rem" }}>
              <div className="card-header bg-success text-white">
                <h6 className="mb-0">Finished Order</h6>
              </div>
              <div className="card-body">
                <Link to="/admin/finishOrderlist">
                  <span className="badge bg-success fs-6">
                    {dashboardData.FinishOrder ?? 0}
                  </span>
                </Link>
              </div>
            </div>

            {/* Pending Message */}
            <div className="card text-center shadow" style={{ width: "18rem" }}>
              <div className="card-header bg-warning text-dark">
                <h6 className="mb-0">Pending Message</h6>
              </div>
              <div className="card-body">
                <Link to={`/admin/pendingMessage/${branchId}`}>
                  <span className="badge bg-warning text-dark fs-6">
                    {dashboardData.pendingMessage ?? 0}
                  </span>
                </Link>
              </div>
            </div>
          </>
        )}
      </div>

      <hr></hr>
      
      <div className="container d-flex justify-content-center align-items-center gap-3 flex-wrap" style={{ minHeight: "30vh" }}>
        <div className="card text-center shadow" style={{ width: "12rem" }}>
          <div className="card-body">
            <Link to= {"/admin/addUser"} >
                <button type="button" class="btn btn-success" >
                    <span><Icon.PersonAdd /> Add User</span>              
                </button>
            </Link>
          </div>
        </div>

        <div className="card text-center shadow" style={{ width: "12rem" }}>
          <div className="card-body">
            <Link to= {"/admin/addProducts"} >
                <button type="button" class="btn btn-success">
                    <span><Icon.UiChecks /> Product List</span>              
                </button>
            </Link>
          </div>
        </div>

      </div>

    </div>

    </>
  );
}

export default Dashboard;